(function (ws) {
    'use strict';
    ws.views.staticTable = ws.views.googleAnalytics.extend({
        events: {
            'click td.control': 'styleChildTr'
        },

        /**
         * Initialize view
         */
        initialize: function() {
            //adjust responsive priority object to corresponds to number of cols in the table (which varies)
            //otherwise, dataTables throws an error
            if (this.responsivePriority) {
                var tableCols = this.$table.find('th').length;
                var itemsToRemove = this.responsivePriority.length - tableCols;
                this.responsivePriority.splice(tableCols, itemsToRemove);
            }

            this.initializeDataTable();
        },

        /**
         * Initialize a DataTable on a provided TABLE element
         * @throws Will throw an error if $table is not defined.
         */
        initializeDataTable: function() {
            if (this.$table === 'undefined') {
                throw new Error('Please provide a table element.');
            }

            var options = {
                responsive: {
                    details: {
                        type: 'inline',
                        target: 0
                    }
                },

                /**
                 * Adjust empty TR if no data to render
                 */
                fnDrawCallback: function () {
                    var rows = this.fnGetData();
                    if (rows.length === 0) {
                        $('td.dataTables_empty').attr('colspan', '100%');
                    }
                },

                info: false,
                searching: false,
                paging: false,
                bSort: false,
                bRetrieve: true,
                columnDefs: [
                    {
                        targets: '_all',
                        width: 'auto'
                    },
                    {
                        targets: 0,
                        className: 'control',
                        orderable: false,
                        width: '10%'
                    }
                ]
            };

            if (this.responsivePriority && typeof this.responsivePriority !== 'undefined') {
                options.columns = this.responsivePriority;
            }

            if (this.emptyTableError && typeof this.emptyTableError !== 'undefined') {
                options.language = {
                    emptyTable: this.emptyTableError
                };
            }

            if (this.emptyTableError && typeof this.emptyTableError !== 'undefined') {
                options.language = {
                    emptyTable: this.emptyTableError
                };
            }

            if (this.stripeClasses && typeof this.stripeClasses !== 'undefined') {
                options.stripeClasses = this.stripeClasses;
            }

            if (this.columnDefs && typeof this.columnDefs !== 'undefined') {
                /**
                 * Mixin columnDefs with a user defined ones and override column definitions if they occur, indexing by
                 * `targets` property, which has to be provided in each column definition
                 */
                options.columnDefs = _.values(_.extend(_.indexBy(options.columnDefs, 'targets'), _.indexBy(this.columnDefs, 'targets')));
            }

            var table = this.$table.DataTable(options);
            table.on('responsive-display.dt', function(e) {
                this.reattachTooltips($(e.currentTarget));
            }.bind(this));
        },

        /**
         * Style child tr when it gets created
         */
        styleChildTr: function(e) {
            var tr = $(e.currentTarget).closest('tr');
            var rowClass = $(tr).attr('class');
            var childTr = $(tr).next();

            if ($(childTr).hasClass('child')) {
                $(childTr).addClass(rowClass);
                $(childTr).removeClass('parent');
            }
        },

        /**
         * Re-attach modals
         * @param {Object} $parent
         */
        reattachTooltips: function($parent) {
            var $tooltips = $parent.find('.comp-tooltip-modal');
            if ($tooltips.length > 0) {
                $tooltips.each(function(index, el) {
                    new ws.views.tooltipModal({
                        el: $(el)
                    });
                });
            }
        }

    });
}(westcon));
